import React from 'react';

import { useTheme } from '../../../../../../hooks/useTheme';

export interface RatingTextProps {
  ratingText: string[];
  ratingNumber: number;
  selectedRating: number;
  isLandscape?: boolean;
  feedbackRatingSubcaption?: string;
}

const RatingText = ({
  ratingText,
  ratingNumber,
  selectedRating,
  isLandscape = false,
  feedbackRatingSubcaption = '',
}: RatingTextProps) => {
  const { bodytextDefaultNone: textStyle } = useTheme();

  let text = <>&nbsp;</>;

  if (ratingNumber > 0) {
    const ratingTextValue = ratingText[ratingNumber - 1];
    text = (
      <>
        {isLandscape || !selectedRating
          ? ratingTextValue
          : `${feedbackRatingSubcaption} ${ratingTextValue.toLowerCase()}?`}
      </>
    );
  }

  return (
    <span data-test="starRatingTextSmallHeader" style={textStyle}>
      {text}
    </span>
  );
};

export default RatingText;
